import script from "./compact-header-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./compact-header-menu.vue?vue&type=script&setup=true&lang=js"

import "./compact-header-menu.vue?vue&type=style&index=0&id=3ea59278&scoped=true&lang=css"

import exportComponent from "/builds/ads-base/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ea59278"]])

export default __exports__